import React, { useState } from "react";
import {
    FaChartLine,
    FaGift,
    FaCoins,
    FaTicketAlt,
    FaCheckCircle,
    FaCheck,
    FaStar,
    FaUsers,
    FaTrophy,
    FaBitcoin,
    FaEthereum,
    FaDollarSign,
    FaChartBar,
    FaSignal,
    FaChartArea,
} from "react-icons/fa";
import "./Invites.css";
import LoginService from "../../../services/Login";

export default function Invites({ onSubmit, onBack }) {
    const [referralCode, setReferralCode] = useState("");
    const [isApplying, setIsApplying] = useState(false);
    const [isSkipping, setIsSkipping] = useState(false);
    const [showSuccess, setShowSuccess] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    const handleApplyReferral = async () => {
        if (!referralCode.trim()) {
            const input = document.getElementById("referral-code");
            input.style.animation = "shake 0.5s";
            input.focus();
            setTimeout(() => {
                onSubmit();
                input.style.animation = "";
            }, 500);
            return;
        }

        setIsApplying(true);
        setErrorMessage("");

        try {
            const body = { referralCode };
            
            const res = await LoginService.referralCode(body);

            if (res.status === 200 || res.status === 201) {
                setShowSuccess(true);
            }
        } catch (err) {
            if (err?.status === 400) {
                setErrorMessage(err?.data?.data?.fa_message || "Invalid referral code.");
            } else {
                setErrorMessage("Error communicating with the server.");
            }
        } finally {
            setIsApplying(false);
        }
    };

    const handleSkipReferral = () => {
        setIsSkipping(true);
        setTimeout(() => {
            onSubmit();
        }, 1500);

    };

    const handleSuccessContinue = () => {
        onSubmit();

    };

    const floatingIcons = [
        { icon: <FaBitcoin />, color: "text-yellow-300", top: "20%", left: "10%", size: "text-3xl", delay: "0s" },
        { icon: <FaDollarSign />, color: "text-white/70", top: "30%", right: "15%", size: "text-2xl", delay: "0.5s" },
        { icon: <FaEthereum />, color: "text-white/60", top: "40%", left: "25%", size: "text-xl", delay: "1s" },
        { icon: <FaChartLine />, color: "text-white/50", top: "10%", right: "20%", size: "text-2xl", delay: "1.2s" },
        { icon: <FaCoins />, color: "text-yellow-200", bottom: "30%", left: "15%", size: "text-xl", delay: "1.4s" },
        { icon: <FaSignal />, color: "text-white/50", bottom: "20%", right: "10%", size: "text-2xl", delay: "1.6s" },
        { icon: <FaChartArea />, color: "text-white/40", bottom: "35%", right: "25%", size: "text-xl", delay: "1.8s" },
        { icon: <FaChartBar />, color: "text-white/60", top: "60%", left: "5%", size: "text-lg", delay: "2s" },
        { icon: <FaUsers />, color: "text-white/50", top: "75%", right: "30%", size: "text-xl", delay: "2.2s" },
        { icon: <FaStar />, color: "text-yellow-400", bottom: "10%", left: "40%", size: "text-2xl", delay: "2.4s" },
    ];

    return (
        <div id="referral-container" className="relative min-h-screen overflow-hidden">
            {/* 🌊 Background */}
            <div className="gradient-bg absolute inset-0">
                <div className="trading-pattern"></div>

                {/* 🌟 Floating Icons */}
                {floatingIcons.map((item, i) => (
                    <div
                        key={i}
                        className={`absolute ${item.color} opacity-40 ${item.size} animate-float`}
                        style={{
                            top: item.top,
                            left: item.left,
                            right: item.right,
                            bottom: item.bottom,
                            animationDelay: item.delay,
                            animationDuration: `${5 + i % 4}s`,
                        }}
                    >
                        {item.icon}
                    </div>
                ))}
            </div>

            <div className="relative z-10 flex flex-col items-center justify-center py-5 min-h-full px-6">
                <div id="logo-section" className="text-center mb-5 fade-in">
                    <div className="inline-flex items-center justify-center w-12 h-12 bg-white rounded-full shadow-lg mb-1 pulse-animation">
                        <FaChartLine className="text-xl text-blue-600" />
                    </div>
                    <h1 className="text-xl font-bold text-white mb-1">7 Trade</h1>
                    <p className="text-blue-100 text-[11px]">Trade Signal Navigator</p>
                </div>

                {!showSuccess && (
                    <div
                        id="referral-box"
                        className={`min-w-[300px] md:min-w-[450px] max-w-[15rem] bg-white rounded-3xl shadow-2xl p-5 slide-up transition-all duration-500 ${
                            isApplying ? "opacity-0 scale-95" : "opacity-100 scale-100"
                        }`}
                    >
                        <div className="text-center mb-5">
                            <div className="inline-flex items-center justify-center w-10 h-10 bg-gradient-to-r from-yellow-400 to-orange-500 rounded-full shadow-lg mb-1 gift-bounce">
                                <FaGift className="text-lg text-white" />
                            </div>
                            <h2 className="text-lg font-bold text-gray-800 mb-1">Have a referral code?</h2>
                            <p className="text-gray-500 text-[11px] leading-relaxed">
                                Enter a referral code and receive{" "}
                                <span className="font-bold text-green-600">50,000 USDT</span>{" "}
                                as a reward
                            </p>
                        </div>

                        <div className="bg-gradient-to-r from-green-50 to-emerald-50 border-2 border-green-200 rounded-2xl p-3 mb-2 relative overflow-hidden">
                            <div className="shimmer absolute inset-0 rounded-2xl"></div>
                            <div className="relative z-10 text-center">
                                <div className="flex items-center justify-center space-x-1 space-x-reverse">
                                    <FaCoins className="text-yellow-500 text-base coin-spin mr-1" />
                                    <span className="text-base font-bold text-green-700">50,000</span>
                                    <span className="text-[13px] text-green-600">USDT</span>
                                </div>
                                <p className="text-green-600 text-[11px] mt-1">Referral code reward</p>
                            </div>
                        </div>

                        <div className="space-y-3">
                            <div className="space-y-1">
                                <label className="text-[11px] font-medium text-gray-700 block text-right">
                                    Referral Code (optional)
                                </label>
                                <div className="relative">
                                    <input
                                        type="text"
                                        id="referral-code"
                                        value={referralCode}
                                        onChange={(e) => setReferralCode(e.target.value)}
                                        placeholder="Enter your referral code"
                                        className="w-full px-3 py-2.5 bg-gray-50 border border-gray-200 rounded-2xl focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent text-right text-[13px]"
                                        dir="rtl"
                                    />
                                    <FaTicketAlt className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 text-xs" />
                                </div>
                            </div>

                            <button
                                id="apply-referral"
                                onClick={handleApplyReferral}
                                disabled={isApplying}
                                className="w-full bg-gradient-to-r from-green-600 to-emerald-600 text-white py-2.5 rounded-2xl font-medium hover:from-green-700 hover:to-emerald-700 transition-all duration-300 shadow-md transform hover:scale-105 text-[13px]"
                            >
                                {isApplying ? "Checking..." : (<><FaCheckCircle className="inline ml-1" /><span className="ml-1">Apply Referral Code</span></>)}
                            </button>

                            <button
                                id="skip-referral"
                                onClick={handleSkipReferral}
                                disabled={isSkipping}
                                className="w-full bg-gray-100 border-2 border-gray-200 text-gray-600 py-2 rounded-2xl font-medium hover:bg-gray-200 transition-colors duration-300 text-[13px]"
                            >
                                {isSkipping ? "Continuing..." : "Skip and Continue"}
                            </button>
                        </div>

                        <div id="benefits-section" className="mt-4 space-y-2 text-[11px]">
                            <div className="flex items-center space-x-2 space-x-reverse text-gray-600">
                                <FaStar className="text-yellow-500 mr-1" />
                                <span className="ml-2">Get 50,000 USDT instantly</span>
                            </div>
                            <div className="flex items-center space-x-2 space-x-reverse text-gray-600">
                                <FaUsers className="text-blue-500 mr-1" />
                                <span className="ml-1">Join the trader network</span>
                            </div>
                            <div className="flex items-center space-x-2 space-x-reverse text-gray-600">
                                <FaTrophy className="text-orange-500 mr-1" />
                                <span className="ml-1">Access to exclusive signals</span>
                            </div>
                        </div>

                        <div id="progress-section" className="mt-4 pt-3 border-t border-gray-100">
                            <div className="flex items-center justify-between text-[10px] text-gray-500 mb-1">
                                <span>Step 4 of 4</span>
                                <span>100%</span>
                            </div>
                            <div className="w-full bg-gray-200 rounded-full h-1">
                                <div
                                    className="bg-gradient-to-r from-blue-600 to-purple-600 h-1 rounded-full transition-all duration-500"
                                    style={{ width: "100%" }}
                                ></div>
                            </div>
                        </div>
                    </div>
                )}

                {showSuccess && (
                    <div id="success-message" className="min-w-[200px] bg-white rounded-3xl shadow-2xl p-5">
                        <div className="text-center">
                            <div className="inline-flex items-center justify-center w-10 h-10 bg-green-500 rounded-full shadow-lg mb-3">
                                <FaCheck className="text-lg text-white" />
                            </div>
                            <h2 className="text-lg font-bold text-gray-800 mb-1">Congratulations!</h2>
                            <p className="text-gray-500 text-[11px] mb-3 leading-relaxed">
                                Your referral code was applied successfully and 50,000 USDT has been added to your account
                            </p>
                            <button
                                id="success-continue-btn"
                                onClick={handleSuccessContinue}
                                className="w-full bg-blue-600 text-white py-2.5 rounded-2xl font-medium hover:bg-blue-700 transition-colors duration-300 text-[13px]"
                            >
                                Continue to Dashboard
                            </button>
                        </div>
                    </div>
                )}

                <div id="footer-text" className="mt-4 text-center fade-in text-[11px]">
                    <p className="text-blue-100">
                        Having trouble?{" "}
                        <span className="text-white underline font-medium cursor-pointer">
              Contact Support
            </span>
                    </p>
                </div>
            </div>
        </div>
    );
}




//
// import React, { useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import {
//     FaChartLine,
//     FaGift,
//     FaCoins,
//     FaTicketAlt,
//     FaCheckCircle,
//     FaCheck,
//     FaStar,
//     FaUsers,
//     FaTrophy,
//     FaBitcoin,
//     FaEthereum,
//     FaDollarSign,
//     FaChartBar,
//     FaSignal,
//     FaChartArea,
// } from "react-icons/fa";
// import "./Invites.css";
//
// export default function Invites({ onSubmit, onBack }) {
//
//     useEffect(() => {
//         const referralCodeInput = document.getElementById("referral-code");
//         const applyReferralBtn = document.getElementById("apply-referral");
//         const skipReferralBtn = document.getElementById("skip-referral");
//         const referralBox = document.getElementById("referral-box");
//         const successMessage = document.getElementById("success-message");
//         const successContinueBtn = document.getElementById("success-continue-btn");
//
//
//         if (!applyReferralBtn || !referralCodeInput) return;
//
//         applyReferralBtn.addEventListener("click", function () {
//             const code = referralCodeInput.value.trim();
//
//             if (code) {
//                 this.innerHTML = "Checking...";
//                 this.disabled = true;
//
//                 setTimeout(() => {
//                     referralBox.style.transform = "scale(0.9)";
//                     referralBox.style.opacity = "0";
//
//                     setTimeout(() => {
//                         referralBox.classList.add("hidden");
//                         successMessage.classList.remove("hidden");
//                         successMessage.style.transform = "scale(1)";
//                         successMessage.style.opacity = "1";
//                     }, 300);
//                 }, 2000);
//             } else {
//                 referralCodeInput.style.animation = "shake 0.5s";
//                 referralCodeInput.focus();
//                 setTimeout(() => {
//                     referralCodeInput.style.animation = "";
//                 }, 500);
//             }
//             successContinueBtn?.addEventListener("click", () => {
//                 onSubmit(); // ✅ Go to main page
//             });
//         });
//
//         skipReferralBtn.addEventListener("click", function () {
//             this.innerHTML = "Continuing...";
//             this.disabled = true;
//             setTimeout(() => {
//                 onSubmit();
//                 console.log("Navigate to dashboard");
//             }, 1500);
//
//         });
//         successContinueBtn?.addEventListener("click", () => {
//
//         });
//     }, [onSubmit]);
//
//     const floatingIcons = [
//         { icon: <FaBitcoin />, color: "text-yellow-300", top: "20%", left: "10%", size: "text-3xl", delay: "0s" },
//         { icon: <FaDollarSign />, color: "text-white/70", top: "30%", right: "15%", size: "text-2xl", delay: "0.5s" },
//         { icon: <FaEthereum />, color: "text-white/60", top: "40%", left: "25%", size: "text-xl", delay: "1s" },
//         { icon: <FaChartLine />, color: "text-white/50", top: "10%", right: "20%", size: "text-2xl", delay: "1.2s" },
//         { icon: <FaCoins />, color: "text-yellow-200", bottom: "30%", left: "15%", size: "text-xl", delay: "1.4s" },
//         { icon: <FaSignal />, color: "text-white/50", bottom: "20%", right: "10%", size: "text-2xl", delay: "1.6s" },
//         { icon: <FaChartArea />, color: "text-white/40", bottom: "35%", right: "25%", size: "text-xl", delay: "1.8s" },
//         { icon: <FaChartBar />, color: "text-white/60", top: "60%", left: "5%", size: "text-lg", delay: "2s" },
//         { icon: <FaUsers />, color: "text-white/50", top: "75%", right: "30%", size: "text-xl", delay: "2.2s" },
//         { icon: <FaStar />, color: "text-yellow-400", bottom: "10%", left: "40%", size: "text-2xl", delay: "2.4s" },
//     ];
//
//     return (
//         <div id="referral-container" className="relative h-screen overflow-hidden">
//             {/* 🌊 Background */}
//             <div className="gradient-bg absolute inset-0">
//                 <div className="trading-pattern"></div>
//
//                 {/* 🌟 Floating Icons */}
//                 {floatingIcons.map((item, i) => (
//                     <div
//                         key={i}
//                         className={`absolute ${item.color} opacity-40 ${item.size} animate-float`}
//                         style={{
//                             top: item.top,
//                             left: item.left,
//                             right: item.right,
//                             bottom: item.bottom,
//                             animationDelay: item.delay,
//                             animationDuration: `${5 + i % 4}s`,
//                         }}
//                     >
//                         {item.icon}
//                     </div>
//                 ))}
//             </div>
//
//             {/* ✅ Content (unchanged) */}
//             <div className="relative z-10 flex flex-col items-center justify-center h-full px-6">
//                 <div id="logo-section" className="text-center mb-5 fade-in">
//                     <div className="inline-flex items-center justify-center w-12 h-12 bg-white rounded-full shadow-lg mb-1 pulse-animation">
//                         <FaChartLine className="text-xl text-blue-600" />
//                     </div>
//                     <h1 className="text-xl font-bold text-white mb-1">7 Trade</h1>
//                     <p className="text-blue-100 text-[11px]">Trade Signal Navigator</p>
//                 </div>
//
//                 {/* ✅ Referral Box (exactly same as original) */}
//                 <div
//                     id="referral-box"
//                     className="w-full max-w-[15rem] bg-white rounded-3xl shadow-2xl p-5 slide-up"
//                 >
//                     <div className="text-center mb-5">
//                         <div className="inline-flex items-center justify-center w-10 h-10 bg-gradient-to-r from-yellow-400 to-orange-500 rounded-full shadow-lg mb-1 gift-bounce">
//                             <FaGift className="text-lg text-white" />
//                         </div>
//                         <h2 className="text-lg font-bold text-gray-800 mb-1">
//                             Have a referral code?
//                         </h2>
//                         <p className="text-gray-500 text-[11px] leading-relaxed">
//                             Enter a referral code and receive{" "}
//                             <span className="font-bold text-green-600">50,000 Toman</span>{" "}
//                             as a reward
//                         </p>
//                     </div>
//
//                     <div className="bg-gradient-to-r from-green-50 to-emerald-50 border-2 border-green-200 rounded-2xl p-3 mb-2 relative overflow-hidden">
//                         <div className="shimmer absolute inset-0 rounded-2xl"></div>
//                         <div className="relative z-10 text-center">
//                             <div className="flex items-center justify-center space-x-1 space-x-reverse">
//                                 <FaCoins className="text-yellow-500 text-base coin-spin mr-1" />
//                                 <span className="text-base font-bold text-green-700">50,000</span>
//                                 <span className="text-[13px] text-green-600">Toman</span>
//                             </div>
//                             <p className="text-green-600 text-[11px] mt-1">Referral code reward</p>
//                         </div>
//                     </div>
//
//                     <div className="space-y-3">
//                         <div className="space-y-1">
//                             <label className="text-[11px] font-medium text-gray-700 block text-right">
//                                 Referral Code (optional)
//                             </label>
//                             <div className="relative">
//                                 <input
//                                     type="text"
//                                     id="referral-code"
//                                     placeholder="Enter your referral code"
//                                     className="w-full px-3 py-2.5 bg-gray-50 border border-gray-200 rounded-2xl focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent text-right text-[13px]"
//                                     dir="rtl"
//                                 />
//                                 <FaTicketAlt className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 text-xs" />
//                             </div>
//                         </div>
//
//                         <button
//                             id="apply-referral"
//                             className="w-full bg-gradient-to-r from-green-600 to-emerald-600 text-white py-2.5 rounded-2xl font-medium hover:from-green-700 hover:to-emerald-700 transition-all duration-300 shadow-md transform hover:scale-105 text-[13px]"
//                         >
//                             <FaCheckCircle className="inline ml-1" />
//                             <span className="ml-1">Apply Referral Code</span>
//                         </button>
//
//                         <button
//                             id="skip-referral"
//                             className="w-full bg-gray-100 border-2 border-gray-200 text-gray-600 py-2 rounded-2xl font-medium hover:bg-gray-200 transition-colors duration-300 text-[13px]"
//                         >
//                             Skip and Continue
//                         </button>
//                     </div>
//
//                     <div id="benefits-section" className="mt-4 space-y-2 text-[11px]">
//                         <div className="flex items-center space-x-2 space-x-reverse text-gray-600">
//                             <FaStar className="text-yellow-500 mr-1" />
//                             <span className="ml-2">Get 50,000 Toman instantly</span>
//                         </div>
//                         <div className="flex items-center space-x-2 space-x-reverse text-gray-600">
//                             <FaUsers className="text-blue-500 mr-1" />
//                             <span className="ml-1">Join the trader network</span>
//                         </div>
//                         <div className="flex items-center space-x-2 space-x-reverse text-gray-600">
//                             <FaTrophy className="text-orange-500 mr-1" />
//                             <span className="ml-1">Access to exclusive signals</span>
//                         </div>
//                     </div>
//
//                     <div id="progress-section" className="mt-4 pt-3 border-t border-gray-100">
//                         <div className="flex items-center justify-between text-[10px] text-gray-500 mb-1">
//                             <span>Step 2 of 3</span>
//                             <span>66%</span>
//                         </div>
//                         <div className="w-full bg-gray-200 rounded-full h-1">
//                             <div
//                                 className="bg-gradient-to-r from-blue-600 to-purple-600 h-1 rounded-full transition-all duration-500"
//                                 style={{ width: "66%" }}
//                             ></div>
//                         </div>
//                     </div>
//                 </div>
//
//                 <div
//                     id="success-message"
//                     className="w-full max-w-[15rem] bg-white rounded-3xl shadow-2xl p-5 hidden"
//                 >
//                     <div className="text-center">
//                         <div className="inline-flex items-center justify-center w-10 h-10 bg-green-500 rounded-full shadow-lg mb-3">
//                             <FaCheck className="text-lg text-white" />
//                         </div>
//                         <h2 className="text-lg font-bold text-gray-800 mb-1">Congratulations!</h2>
//                         <p className="text-gray-500 text-[11px] mb-3 leading-relaxed">
//                             Your referral code was applied successfully and 50,000 Toman has been added to your account
//                         </p>
//                         <button className="w-full bg-blue-600 text-white py-2.5 rounded-2xl font-medium hover:bg-blue-700 transition-colors duration-300 text-[13px]">
//                             Continue to Dashboard
//                         </button>
//                     </div>
//                 </div>
//
//                 <div id="footer-text" className="mt-4 text-center fade-in text-[11px]">
//                     <p className="text-blue-100">
//                         Having trouble?{" "}
//                         <span className="text-white underline font-medium cursor-pointer">
//                             Contact Support
//                         </span>
//                     </p>
//                 </div>
//             </div>
//         </div>
//     );
// }